import moment from "moment";
import { Carousel } from "react-responsive-carousel";
import { capitalFirstLetter, findTypeLabel } from "../../../utils";
import InAndOutTownUsage from "../../InAndOutTownUsage";
import OutIslandUsage from "../../OutIslandUsage";
import PlaceholderImg from "../../../images/components/placeholder.jpg";
import { useEffect } from "react";
import InsuranceSelector from "../InsuranceSelector";
import PriceEstimate from "../../PriceEstimate";

const Step1 = ({ formik, data, insurances, insuranceLoading, priceCalculate, t }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      {/* Car Info Section */}
      <div className="booking-modal__car-info">
        <div className="dates-div">
          <div className="booking-modal__car-info__dates">
            <h5>Booking</h5>
            <span>
              <i className="fa-solid fa-car"></i>
              <div>
                <h6>{data?.conditions?.with_driver ? t("with_driver") : t("without_driver")}</h6>
                <p>{findTypeLabel(data?.type)}</p>
              </div>
            </span>
            <h5>{t("location_n_date")}</h5>
            <span>
              <i className="fa-solid fa-location-dot"></i>
              <div>
                <h6>{t("pickup_date_n_time")}</h6>
                <p>{moment(data?.pickup_date).format("DD/MM/YYYY [-] HH:mm")}</p>
              </div>
            </span>
          </div>

          {data?.type !== "transfer_service" && (
            <div className="booking-modal__car-info__dates">
              <span>
                <i className="fa-solid fa-location-dot"></i>
                <div>
                  <h6>{t("dropoff_date_n_time")}</h6>
                  <p>
                    {(() => {
                      if (data?.type === "tour") {
                        const pickup = moment(data?.pickup_date, "YYYY/MM/DD HH:mm");
                        const daysToAdd = Number(data?.duration) - 1;
                        const hoursToAdd = Number(data?.tourPackage);

                        const dropoff = pickup.clone().add(daysToAdd, "days").add(hoursToAdd, "hours");

                        return dropoff.format("DD/MM/YYYY [-] HH:mm");
                      }

                      return moment(data?.dropoff_date).format("DD/MM/YYYY [-] HH:mm");
                    })()}
                  </p>
                </div>
              </span>
            </div>
          )}

          <div className="booking-modal__car-info__dates">
            <span>
              <i className="fa-solid fa-calendar-days"></i>
              <div>
                <h6>{t("pickup_location")}</h6>
                <p>{data?.pickup_location}</p>
              </div>
            </span>
          </div>

          {data.type !== "tour" ? (
            <div className="booking-modal__car-info__dates">
              <span>
                <i className="fa-solid fa-calendar-days"></i>
                <div>
                  <h6>{t("dropoff_location")}</h6>
                  <p>{data?.dropoff_location}</p>
                </div>
              </span>
            </div>
          ) : null}
        </div>
        <div className="booking-modal__car-info__model">
          <h5>
            <span>
              {t("car")} - {capitalFirstLetter(data?.car?.brands)} {capitalFirstLetter(data?.car?.name)}
            </span>
          </h5>
          {data?.car?.image_urls[0] ? (
            <Carousel dynamicHeight>
              {data.car?.image_urls.map((item, idx) => {
                return (
                  <div key={idx}>
                    <img src={item} alt="car images" />
                  </div>
                );
              })}
            </Carousel>
          ) : (
            <img src={PlaceholderImg} width={"100%"} alt="" />
          )}
        </div>
      </div>

      {data?.type === "tour" ? <InAndOutTownUsage /> : null}
      {data?.type === "self_drive" ? <OutIslandUsage /> : null}

      {data?.type === "self_drive" ? (
        <InsuranceSelector insurances={insurances} insuranceLoading={insuranceLoading} formik={formik} t={t} />
      ) : null}

      {/* Price Estimate */}
      <div className="px-[3rem]">
        <PriceEstimate priceCalculate={priceCalculate} type={data?.type} />
      </div>
    </div>
  );
};

export default Step1;
